export default __webpack_public_path__ + "static/media/welcome.8462d6b2.png";